import React from "react";

export const Loading = () => (
  <svg
    width="75"
    height="75"
    viewBox="0 0 246 246"
    style={{
      top: "50%",
      left: "50%",
      marginTop: 0,
      marginLeft: 0,
      position: "absolute",
      animation: "rotateBy90 1.5s linear infinite",
    }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Tournify Logo</title>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Group" transform="translate(-0.000000, 0.000000)">
        <rect id="Rectangle" x="0" y="0" width="246" height="246" fill="none" />
        <path
          d="M160.7,101.7 L160.7,101.7 L10,101.7 C8.5,101.7 7.5,100 8.3,98.7 L44.2,36.5 C44.8,35.6 45.7,35 46.8,35 L122.2,35 C156.4,35 177.9,72 160.7,101.7 Z M201,38 C200.2,36.7 198.3,36.7 197.5,38 L160.7,101.7 L122.2,168.4 L122.2,168.4 C139.3,198.1 182.1,198.1 199.3,168.4 L199.3,168.4 L237,103.2 C237.5,102.3 237.5,101.1 237,100.2 L201,38 Z M159,232 L83.6,101.7 L83.6,101.7 C49.3,101.7 27.9,138.7 45.1,168.4 L45.1,168.4 L82.8,233.6 C83.3,234.5 84.3,235.1 85.4,235.1 L157.3,235.1 C158.8,235 159.8,233.3 159,232 Z"
          id="Shape"
          fill="#3514FF"
          fillRule="nonzero"
        />
      </g>
    </g>
  </svg>
);
